import {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../../selectors/pages/deposit/cashapp';
import {getCashAppRecipient, createCashAppOrder} from '../../../../../reducers/app/actions';
import {useNavigate, useLocation} from 'react-router-dom';

import LoaderPage from '../../../../components/loader_page';

import Enter from './enter';
import Send from './send';
import Alert from './alert';
import Guide from './guide';

export default ({setMethod}) => {
    const {cashapp_order, button} = useSelector(Selector),
          dispatch = useDispatch(),
          navigate = useNavigate(),
          location = useLocation();

    const stageEventHandler = e => {
        setStage(e.detail.stage);
        setData(e.detail.data);
        // console.log(e.detail);
    }


    const [guide, setGuide] = useState(false),
          [stage, setStage] = useState('enter'),
          [data, setData] = useState(null);

    useEffect(() => {
        document.addEventListener('cashapp.stage', stageEventHandler);

        return () => {
            document.removeEventListener('cashapp.stage', stageEventHandler);
        }
    }, [location]);

    // useEffect(() => {
    //     if(!cashapp_recipient)
    //         dispatch(getCashAppRecipient(navigate));
    // }, [cashapp_recipient]);

    // if(!cashapp_recipient)
    //     return <LoaderPage />

    if(!guide)
        return <Guide onNext={() => setGuide(true)} />

    if(stage === "enter")
        return <Enter button={button} setMethod={setMethod} onNext={data => {
            data = {
                ...data,
                amount: parseFloat(parseFloat(data.amount).toFixed(2))
            };

            dispatch(createCashAppOrder({
                data: {
                    amount: data.amount,
                    cashtag: data.cashtag
                },
                _: {
                    data,
                    stage: 'send'
                }
            }, navigate));
        }} />

    if(stage === "send")
        return <Send data={data} order={cashapp_order} onPayment={() => setStage('alert')} />;

    return <Alert order={cashapp_order} />
}